export default __webpack_public_path__ + "static/gallery-award-civic-0b61bc80cb0f975b1dc1425ea7e7394b.jpg";